import { ObjectHelper } from '@osapp/helpers/objectHelper';

export class SearchPatientsError extends Error {

	constructor(psMessage: string) {
		super(psMessage);
		// Nécessaire pour que le 'instanceof SearchPatientsError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, SearchPatientsError);
	}

}